/**
 * ゲームレジストリ
 *
 * ── 新しいゲームを追加する手順 ──────────────────────────────────────────────
 * 1. ゲームコンポーネントを作成し、`isPreview` prop を受け取れるようにする
 *    （isPreview=true のとき: キーボード/タッチリスナー・ゲームループを起動しない）
 * 2. 下の GAMES 配列に1エントリ追加するだけ。他のファイルは触らなくてよい。
 * ────────────────────────────────────────────────────────────────────────────
 */
import React from 'react';

export const GAMES = [
  {
    path:        '/games/timer3',
    component:   React.lazy(() => import('./Timer5Game')),
    emoji:       '⏱️',
    title:       '3.0000000秒ぴったりストップウォッチ',
    description: 'スタートを押してちょうど3秒でストップ！\n0.7秒以降はタイマーが消えるよ。',
  },
  {
    path:        '/games/beam-neko',
    component:   React.lazy(() => import('./ball-dodge/BallDodgeGame')),
    emoji:       '🐱',
    title:       'ビームねこ',
    description: 'ヘビをビームで倒せ！\nどんどん敵が増えてくるぞ。',
  },
  {
    path:        '/games/stock-market',
    component:   React.lazy(() => import('./stock-market/StockMarketGame')),
    emoji:       '📈',
    title:       '株式売買ゲーム',
    description: '毎時00分〜54分が取引時間！株を売り買いして損益を競え。',
  },
];

/** パスのみの配列（ルート生成・インデックス計算に使用） */
export const GAME_PATHS = GAMES.map(g => g.path);
